<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Items From Work Order"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create payment items from work orders."
      @on-submit="createTechnicianPaymentItemsFromWorkOrderImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Technician Payment Items From Work Order Template.xlsx"
              :file-provider="$importsAPI.getTechnicianPaymentItemsFromWorkOrderTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianPaymentItemsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'technician-payment-items-from-work-order-imports-add-modal',
    };
  },
  methods: {
    createTechnicianPaymentItemsFromWorkOrderImport(data, handleCreate) {
      handleCreate(this.$importsAPI.technicianPaymentItemsFromWorkOrderCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
